export const ThirdPartyUid = {
  namespaced: true,
  state: {
    lineUid: '',
    siwaUid: ''
  },
  getters: {
    lineUid: state => state.lineUid,
    siwaUid: state => state.siwaUid
  },
  mutations: {
    SET_LINE_UID (state, item) {
      state.lineUid = item
    },
    SET_SIWA_UID (state, item) {
      state.siwaUid = item
    }
  },
  actions: {
    setLineUid: ({ commit }, lineUid) => {
      commit('SET_LINE_UID', lineUid)
    },
    setSIWAUid: ({ commit }, siwaUid) => {
      commit('SET_SIWA_UID', siwaUid)
    }
  }
}
